import { Box, Divider, Typography } from "@mui/material"
import { Info } from "@mui/icons-material"
import { useMemo } from "react"
import { Formater, TypeRecords } from "src/framework/commons/Formater"
import { useProjetosOffGridStore } from "src/store/vendas/projetos/offgrid.store"
import { servicoInformationModalIsOpenedStore$ } from "src/store/vendas/projetos/store"

export const ResumoMobile = () => {
  const { resultado_calculos, valor_servico_pis_cofins } = useProjetosOffGridStore(store => store.state.data)

  const resumoFields = useMemo(()=>{
    return [
      {
        label: "Potência do gerador (kWp)",
        value: Number(resultado_calculos?.componentes?.potencia_gerador || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      },
      {
        label: "Valor dos produtos",
        value: Formater.toString(resultado_calculos?.componentes?.valor || 0, TypeRecords.CURRENCY),
      },
      {
        label: "Valor do serviço da revenda com PIS/COFINS",
        value: Formater.toString(valor_servico_pis_cofins || 0, TypeRecords.CURRENCY),
        prefixIcon: (
          <Info style={{ cursor: 'pointer', paddingTop: "5px" }} onClick={() => servicoInformationModalIsOpenedStore$.next(true)} color="primary" />
        ),
        hide: !valor_servico_pis_cofins || valor_servico_pis_cofins === 0
      },
      {
        label: 'Valor total',
        value: Formater.toString((resultado_calculos?.servicos?.valor_com_pis_cofins || 0) + (resultado_calculos?.componentes?.valor || 0), TypeRecords.CURRENCY)
      }
    ]
  },[resultado_calculos?.componentes?.potencia_gerador, resultado_calculos?.componentes?.valor, resultado_calculos?.servicos?.valor_com_pis_cofins, valor_servico_pis_cofins])

  return (
    <Box style={{padding: '16px 4px 24px 16px'}}>
      <Box style={{display: "flex", flexDirection: "column", gap: 8}}>
        <Box>
          <Typography align='left' color='primary' variant='h6'><strong>Resumo do projeto:</strong></Typography>
        </Box>

        {resumoFields.filter(item => !item.hide).map(item => (
          <>
            {item.label==="Valor total" && (
                <Box style={{width: "97%"}}>
                    <Divider />
                </Box>
            )} 
            <Box display="flex" width="100%">
                <Box display='flex' width='60%' alignItems={'center'} flexDirection={"row"} justifyContent={"flex-start"}>
                <Typography style={{ textAlign: "start", fontSize: "12px", alignContent: "center", justifyContent: "center" }} variant='subtitle1'>{item.label}{item.prefixIcon}</Typography>
                </Box>
                <Box display='flex' justifyContent={"flex-end"} alignItems={'flex-start'} width='40%' flexDirection={"row"}>
                <Typography style={{ marginLeft: 10, textAlign: "left", paddingRight: "5px", fontSize: "12px" }} variant='subtitle1'>{item.value}</Typography>
                </Box>
            </Box>
          </>
        ))}
      </Box>
    </Box>
  )
}